<template>
    <div class="body-card-border-primary container col-sm-5">
        <h2 class="pull-center">Iniciar sesión</h2>
        
        <hr>

        <b-overlay :show="showOverlay" rounded="sm">
            <form>
                <div class="row margin-bottom">
                    <div class="col-sm-2"></div>

                    <div class="col-sm-8">
                        <label>Email</label>
                        
                        <input
                            type="email"
                            placeholder="Ingresá el Email"
                            class="form-control"
                            v-model="user.userName" />
                        <small v-if="errorUserNameRequired">Es un campo requerido</small>
                    </div>
                </div>

                <div class="row margin-bottom">
                    <div class="col-sm-2"></div>

                    <div class="col-sm-8">
                        <label>Password</label>
                        
                        <input 
                            type="password"
                            placeholder="Ingresá la Contraseña"
                            class="form-control"
                            v-model="user.password"
                            @keyup.enter="postLogin()">

                        <small v-if="errorPasswordRequired">Es un campo requerido</small>
                    </div>
                </div>
                    <!-- <div class="col-sm-6 pull-left my-1">
                        <a href="/ForgotPassword"><strong>Olvidaste tu contraseña?</strong></a>
                    </div> -->
                <div class="row">
                    <div class="pull-right">                        
                        <button class="btn-secondary" type="button" v-on:click="goRegister()">Registrar</button>

                        <button 
                            class="btn-primary margin-left"
                            type="button"
                            v-on:click="postLogin()">
                            Iniciar sesión
                        </button>
                    </div>
                </div>
            </form>
        </b-overlay>
    </div>
</template>

<script>
import "@/assets/style.css"
import { mapActions } from "vuex";
import API_ROUTES from '@/api/routes';

export default {
    data() {
        return {
            showOverlay: false,
            //user: { userName: "facu.espilocin@hotmail.com", password: "123456" },
            user: { userName: "", password: "" },
            errorUserNameRequired: false,
            errorPasswordRequired: false,
        }
    },

    created() { 
    },

    methods: {
        ...mapActions(["setJWTToken", "setUserData", "setResetPasswordState"]),

        async postLogin() {
            //console.log("User in context: ");
            //console.log(this.user);
            this.showOverlay = true;

            let isValid = this.validateFields();

            if (isValid) {
                this.$axios.post(API_ROUTES.POST_AUTH, this.user)
                .then(res => {
                    //console.log(res.data);
                    
                    if (res.data?.errors?.length >= 1) {
                        const errorMessages = res.data.errors.map(error => error.errorMessage);
                        this.showNotification("error", ...errorMessages);
                    } else {
                        this.setJWTToken(res.data.data.token);
                        this.setUserData(res.data.data.userData);
                        window.location.href = "/";
                    }
                })
                .catch(e => {
                    //console.log(e);
                    this.showNotification("error", e.response);
                })
                .finally(e => {
                    this.showOverlay = false;
                })
            } else {
                this.showOverlay = false;
            }
        },

        goRegister() {
            window.location.href = "/Register";
        },

        validateFields() {
            let result = true;

            if (this.user.userName === "") {
                this.errorUserNameRequired = true;
                result = false;
            } else {
                this.errorUserNameRequired = false;
            }

            if (this.user.password === "") {
                this.errorPasswordRequired = true;
                result = false;
            } else {
                this.errorPasswordRequired = false;
            }
            
            return result;
        },

        showNotification(type, text) {
            this.$toasted.show(text, {
                duration: 5000,
                type: type,
                theme: "bubble",
                singleton: true,
                action: {
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                },
            });
        },
    }
}
</script>